import { render, staticRenderFns } from "./MailLink.vue?vue&type=template&id=14f8a66e&"
import script from "./MailLink.vue?vue&type=script&lang=js&"
export * from "./MailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14f8a66e')) {
      api.createRecord('14f8a66e', component.options)
    } else {
      api.reload('14f8a66e', component.options)
    }
    module.hot.accept("./MailLink.vue?vue&type=template&id=14f8a66e&", function () {
      api.rerender('14f8a66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yrJT3KKmu2fg/JS/comp/MailLink.vue"
export default component.exports